import React, { useCallback, useMemo } from "react";

import { Button } from "../../components";
import { useStore } from "../../store";
import { isTreeFilter, isValueFilter } from "../../utils";
import "./Modals.scss";

export const TutorialModal = ({ className = "", style = {} }) => null;

export const StoryModal = ({
  className = "",
  style = {},
  onClose = () => {},
}) => {
  const { showNotes, selected } = useStore(
    useCallback((state) => state.platform.story, [])
  );
  return showNotes ? (
    <div className={`story-modal ${className}`} style={{ ...style }}>
      <div className="story-modal__content flex flex-column content-between">
        <div
          className="story-modal__close self-end z3 pointer"
          onClick={onClose}
        >
          <svg role="img" aria-label="Close lightbox">
            <use xlinkHref="#close-icon"></use>
          </svg>
        </div>
        <div
          className="story-modal__text"
          dangerouslySetInnerHTML={{ __html: selected?.notes }}
        ></div>
      </div>
    </div>
  ) : null;
};

export const NoDataModal = ({ className = "", style = {} }) => {
  const filters = useStore(useCallback((state) => state.filters, []));
  const dispatch = useStore(useCallback((state) => state.dispatch, []));

  const resetFilterDimension = useCallback(
    (key) => () => {
      dispatch({
        type: "RESET_FILTER_DIMENSION",
        payload: key,
      });
    },
    [dispatch]
  );

  // Is any filter from the filter group active?
  const isFilterActive = useMemo(() => {
    return Object.values(filters).reduce((acc, curr) => {
      // if filter tree
      if (isTreeFilter(curr)) {
        return curr.selected.length > 0 || acc;
      } else if (isValueFilter(curr)) {
        // value filter, like text
        return curr.value !== "" || acc;
      } else {
        // any other filter type
        return acc;
      }
      // return curr.all ? curr.selected.length > 0 || acc : acc;
    }, false);
  }, [filters]);

  // TODO This doesn't reset text filters probably but I prefer to keep the
  // filter reset dialogue regardless
  return isFilterActive ? (
    <div className={` ${className}`} style={{ ...style }}>
      <div className="flex flex-column center items-center">
        <div className="mb2">
          No data for this combination of selected filters
        </div>
        {Object.entries(filters).map(
          ([filterKey, o]) =>
            ((o?.all && o.selected.length > 0) ||
              (o?.value && o.value !== "")) && (
              <div
                className="flex flex-row items-center mb2 h4 col-12"
                key={`no-data-filter-reset-${filterKey}`}
              >
                <div className={`bold mr2 col-6 flex justify-end`}>
                  {filterKey.replace("_", " ")}
                  {/* ({o.selected.length} selected) */}
                </div>
                <Button
                  className="block-font uppercase"
                  onClick={resetFilterDimension(filterKey)}
                >
                  Reset
                </Button>
              </div>
            )
        )}
      </div>
    </div>
  ) : null;
};
